module.exports = __webpack_public_path__ + "img/alcohol-alliance-barnsley-logo.e6fb91c4.png";